import { CompanyName, CompanyTitle } from './clientConfigs';

export function updateDocumentTitle(newTitle?: string): void {
  if (newTitle) {
    document.title = formatTitle(newTitle);
  } else {
    document.title = CompanyTitle;
  }
}

function formatTitle(title: string): string {
  return title + ' | ' + CompanyName;
}
